/*
>> Theme constant containing theme specs
*/

const currentYear = new Date().getFullYear();

export const helmsmarthomeTheme = {
  // colors
  navbarBgColor: "bg-white",
  navbarTextColor: "text-[#494e52]",
  navbarTextHoverColor: "hover:text-[#f29d23]",
  footerBgColor: "bg-[#243746]",
  footerTextColor: "text-white",
  secondaryNavMenuItemBgColor: "bg-white",
  secondaryNavActiveMenuItem: "border-2 border-[#ffa400]",
  buttonBgColor: "bg-[#ffa400]",
  buttonHoverBgColor: "hover:bg-[#f29d23]",
  redirectingTextColor: "text-gray-700",
  redirectingBorder: "border border-b-4 border-b-[#ffa400]",
  // file paths
  logo: "/helm_logo.svg",
  footerLogo: "/helm_logo_footer.svg",
  title: "Helm Smart Home",
  favicon: "/Helm/favicon.ico",
  copyrightText: `Copyright &copy;${currentYear} Helm Smart Home. All Rights Reserved.`,
};

let COGNITO_DOMAIN = "";
let COGNITO_REDIRECTSIGNIN = "";
let COGNITO_REDIRECTSIGNOUT = "";
let COGNITO_REDIRECT_URI = "";
let COGNITO_REGION = "";
let SHOP_URL = "";
let MARKETING_URL = "";
let ACCOUNT_URL = "";
let COOKIE_STORAGE_DOMAIN = "";
let ACCOUNT_API_URL = "";
let COGNITO_APP_CLIENT_ID = "";
let COGNITO_USER_POOL_ID = "";

if (process.env.REACT_APP_MODE === "local") {
  COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
  COGNITO_REDIRECTSIGNIN = process.env.REACT_APP_COGNITO_REDIRECTSIGNIN;
  COGNITO_REDIRECTSIGNOUT = process.env.REACT_APP_COGNITO_REDIRECTSIGNOUT;
  COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI;
  COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
  SHOP_URL = process.env.REACT_APP_SHOP_URL;
  MARKETING_URL = process.env.REACT_APP_MARKETING_URL;
  ACCOUNT_URL = process.env.REACT_APP_ACCOUNT_URL;
  COOKIE_STORAGE_DOMAIN = process.env.REACT_APP_COOKIE_STORAGE_DOMAIN;
  ACCOUNT_API_URL = process.env.REACT_APP_ACCOUNT_API_URL;
  COGNITO_APP_CLIENT_ID = process.env.REACT_APP_COGNITO_APP_CLIENT_ID;
  COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
} else if (process.env.REACT_APP_MODE === "develop") {
  COGNITO_DOMAIN =
    "helm-ecommweb-430666279062.auth.us-east-2.amazoncognito.com";
  COGNITO_REDIRECTSIGNIN = "https://account-dev.helmsmarthome.com/redirecting";
  COGNITO_REDIRECTSIGNOUT = "https://account-dev.helmsmarthome.com";
  COGNITO_REDIRECT_URI = "https://account-dev.helmsmarthome.com/redirecting";
  COGNITO_REGION = "us-east-2";
  SHOP_URL = "https://shop-dev.helmsmarthome.com";
  MARKETING_URL = "https://dev.helmsmarthome.com";
  ACCOUNT_URL = "https://account-dev.helmsmarthome.com";
  COOKIE_STORAGE_DOMAIN = "helmsmarthome.com";
  ACCOUNT_API_URL = "https://vdmnc1jk7e.execute-api.us-east-2.amazonaws.com/v1";
  COGNITO_APP_CLIENT_ID = "2oie2irj5e3ine39a2d5qcoebf";
  COGNITO_USER_POOL_ID = "us-east-2_M2sycxTX2";
} else if (process.env.REACT_APP_MODE === "master") {
  COGNITO_DOMAIN =
    "helm-ecommweb-832527406606.auth.us-east-2.amazoncognito.com";
  COGNITO_REDIRECTSIGNIN = "https://account.helmsmarthome.com/redirecting";
  COGNITO_REDIRECTSIGNOUT = "https://account.helmsmarthome.com";
  COGNITO_REDIRECT_URI = "https://account.helmsmarthome.com/redirecting";
  COGNITO_REGION = "us-east-2";
  SHOP_URL = "https://shop.helmsmarthome.com";
  MARKETING_URL = "https://helmsmarthome.com";
  ACCOUNT_URL = "https://account.helmsmarthome.com";
  COOKIE_STORAGE_DOMAIN = "helmsmarthome.com";
  ACCOUNT_API_URL = "https://zwb3bq2rr9.execute-api.us-east-2.amazonaws.com/v1";
  COGNITO_APP_CLIENT_ID = "32jnk8kdb7ubmtmu2oc0pm8h4l";
  COGNITO_USER_POOL_ID = "us-east-2_FFpBaFTjx";
}

export const helmConstants = {
  ACCOUNT_API_URL,
  COGNITO_APP_CLIENT_ID,
  COGNITO_USER_POOL_ID,
  COGNITO_DOMAIN: COGNITO_DOMAIN,
  COGNITO_REDIRECTSIGNIN: COGNITO_REDIRECTSIGNIN,
  COGNITO_REDIRECTSIGNOUT: COGNITO_REDIRECTSIGNOUT,
  COGNITO_REDIRECT_URI: COGNITO_REDIRECT_URI,
  COGNITO_REGION: COGNITO_REGION,
  SHOP_URL: SHOP_URL,
  MARKETING_URL: MARKETING_URL,
  ACCOUNT_URL: ACCOUNT_URL,
  TERMS_AND_CONDITIONS_URL: `${MARKETING_URL}/terms-and-conditions`,
  PRIVACY_POLICY_URL: `${MARKETING_URL}/privacy-policy`,
  COOKIE_STORAGE_DOMAIN: COOKIE_STORAGE_DOMAIN,
  COOKIE_STORAGE_PATH: "/",
  COOKIE_STORAGE_EXPIRES: 7,
  COOKIE_STORAGE_SECURE: false,
  COOKIE_MAX_AGE: 2592000,
};

export default {
  helmsmarthomeTheme,
  helmConstants,
};
